import eventsService from "../../../services/eventsService";
import organizersService from "../../../services/organizersService";
import PageLoader from "../../common/controls/pageloader";
import config from "../../../config";
import rules from "../../../utils/utils";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";
export default {
  name: "addevent",
  components: { PageLoader, pageheader },
  props: [],
  data() {
    return {
      showloadingSection: false,
      eventId: this.$route.params.eventId,
      operation: "add",
      stime: "",
      etime: "",
      org: [],
      input: {},
      eventyTypesList: config.eventyTypesList,
      selectedEventType: null,
      isFormValid: false,
      isaddingEvent: false,
      showDailySection: false,
      showWeeklySection: false,
      showMonthlySection: false,
      recurrencePatternRadioGroup: "Weekly",
      dailyOptionRadiogroup: "",
      timeslotsData: [
        {
          startTime: "",
          endTime: "",
          organizers: []
        }
      ],

      resultArray: [],
      addEventPayLoad: {},
      txtEventTitle: "",
      txtEventDescription: "",
      selectedWeekdays: [],
      txtMonthlyDay: null,
      startDatePicker: new Date().toISOString().substr(0, 10),
      endDatePicker: new Date().toISOString().substr(0, 10),
      startDateFormatted: this.formatDate(
        new Date().toISOString().substr(0, 10)
      ),
      endDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      startSlot: "",
      endSlot: "",
      txtLocation: "",
      selectedTimeZone: "",
      timeSlots: [
        { text: "12:00 AM", value: "00:00" },
        { text: "12:15 AM", value: "00:15" },
        { text: "12:30 AM", value: "00:30" },
        { text: "12:45 AM", value: "00:45" },
        { text: "1:00 AM", value: "01:00" },
        { text: "1:15 AM", value: "01:15" },
        { text: "1:30 AM", value: "01:30" },
        { text: "1:45 AM", value: "01:45" },
        { text: "2:00 AM", value: "02:00" },
        { text: "2:15 AM", value: "02:15" },
        { text: "2:30 AM", value: "02:30" },
        { text: "2:45 AM", value: "02:45" },
        { text: "3:00 AM", value: "03:00" },
        { text: "3:15 AM", value: "03:15" },
        { text: "3:30 AM", value: "03:30" },
        { text: "3:45 AM", value: "03:45" },
        { text: "4:00 AM", value: "04:00" },
        { text: "4:15 AM", value: "04:15" },
        { text: "4:30 AM", value: "04:30" },
        { text: "4:45 AM", value: "04:45" },
        { text: "5:00 AM", value: "05:00" },
        { text: "5:15 AM", value: "05:15" },
        { text: "5:30 AM", value: "05:30" },
        { text: "5:45 AM", value: "05:45" },
        { text: "6:00 AM", value: "06:00" },
        { text: "6:15 AM", value: "06:15" },
        { text: "6:30 AM", value: "06:30" },
        { text: "6:45 AM", value: "06:45" },
        { text: "7:00 AM", value: "07:00" },
        { text: "7:15 AM", value: "07:15" },
        { text: "7:30 AM", value: "07:30" },
        { text: "7:45 AM", value: "07:45" },
        { text: "8:00 AM", value: "08:00" },
        { text: "8:15 AM", value: "08:15" },
        { text: "8:30 AM", value: "08:30" },
        { text: "8:45 AM", value: "08:45" },
        { text: "9:00 AM", value: "09:00" },
        { text: "9:15 AM", value: "09:15" },
        { text: "9:30 AM", value: "09:30" },
        { text: "9:45 AM", value: "09:45" },
        { text: "10:00 AM", value: "10:00" },
        { text: "10:15 AM", value: "10:15" },
        { text: "10:30 AM", value: "10:30" },
        { text: "10:45 AM", value: "10:45" },
        { text: "11:00 AM", value: "11:00" },
        { text: "11:15 AM", value: "11:15" },
        { text: "11:30 AM", value: "11:30" },
        { text: "11:45 AM", value: "11:45" },
        { text: "12:00 PM", value: "12:00" },
        { text: "12:15 PM", value: "12:15" },
        { text: "12:30 PM", value: "12:30" },
        { text: "12:45 PM", value: "12:45" },
        { text: "1:00 PM", value: "13:00" },
        { text: "1:15 PM", value: "13:15" },
        { text: "1:30 PM", value: "13:30" },
        { text: "1:45 PM", value: "13:45" },
        { text: "2:00 PM", value: "14:00" },
        { text: "2:15 PM", value: "14:15" },
        { text: "2:30 PM", value: "14:30" },
        { text: "2:45 PM", value: "14:45" },
        { text: "3:00 PM", value: "15:00" },
        { text: "3:15 PM", value: "15:15" },
        { text: "3:30 PM", value: "15:30" },
        { text: "3:45 PM", value: "15:45" },
        { text: "4:00 PM", value: "16:00" },
        { text: "4:15 PM", value: "16:15" },
        { text: "4:30 PM", value: "16:30" },
        { text: "4:45 PM", value: "16:45" },
        { text: "5:00 PM", value: "17:00" },
        { text: "5:15 PM", value: "17:15" },
        { text: "5:30 PM", value: "17:30" },
        { text: "5:45 PM", value: "17:45" },
        { text: "6:00 PM", value: "18:00" },
        { text: "6:15 PM", value: "18:15" },
        { text: "6:30 PM", value: "18:30 " },
        { text: "6:45 PM", value: "18:45" },
        { text: "7:00 PM", value: "19:00" },
        { text: "7:15 PM", value: "19:15" },
        { text: "7:30 PM", value: "19:30" },
        { text: "7:45 PM", value: "19:45" },
        { text: "8:00 PM", value: "20:00" },
        { text: "8:15 PM", value: "20:15" },
        { text: "8:30 PM", value: "20:30" },
        { text: "8:45 PM", value: "20:45" },
        { text: "9:00 PM", value: "21:00" },
        { text: "9:15 PM", value: "21:15" },
        { text: "9:30 PM", value: "21:30" },
        { text: "9:45 PM", value: "21:45" },
        { text: "10:00 PM", value: "22:00" },
        { text: "10:15 PM", value: "22:15" },
        { text: "10:30 PM", value: "22:30" },
        { text: "10:45 PM", value: "22:45" },
        { text: "11:00 PM", value: "23:00" },
        { text: "11:15 PM", value: "23:15" },
        { text: "11:30 PM", value: "23:30" },
        { text: "11:45 PM", value: "23:45" }
      ],
      organizersList: [],
      timeZonesList: [],
      organizers: [],
      startDateMenu: false,
      endDateMenu: false,
      rules: rules.getRules(),
      openedPanel: [],
      isExpanded: false,
      showbanner:true
    };
  },
  computed: {
    ...mapGetters(["roles"])
  },
  filters: {
    lowercase: function(value) {
      if (value) {
        return value.toLowerCase();
      }
    },
  },
  mounted() {
    this.input = utils.getInputContent("addevents", this.roles);
    this.onRecurrenceChange();
    this.getOrganizersList();
    this.getTimeZones();

    if (this.eventId != null && this.eventId != "") {
      this.operation = "update";
      this.showloadingSection = true;
      // this.populateEventDetails();
    } else {
      this.operation = "add";
    }
  },
  watch: {
    startDatePicker() {
      this.startDateFormatted = this.formatDate(this.startDatePicker);
    },
    endDatePicker() {
      this.endDateFormatted = this.formatDate(this.endDatePicker);
    }
  },
  methods: {
    backToEvents() {
      this.$router.push("/events/all");
    },
    getTimeZones() {
      eventsService.getTimeZones(
        this,
        response => {
          if (response.length > 0) {
            this.timeZonesList = response;
          }
        },
        error => {
          console.log(error);
          this.$toast.error("unable to get timezones. Please try again later");
        }
      );
    },
    getOrganizersList() {
      organizersService.getOrganizers(
        this,
        response => {
          if (response.length > 0) {
            response.map(item => {
              item.name = item.firstName + " " + item.lastName;
            });
            this.organizersList = response;
          }
        },
        error => {
          console.log(error);
          this.$toast.error("unable to get organizers. Please try again later");
        }
      );
    },
    onRecurrenceChange() {
      if (this.recurrencePatternRadioGroup == "Daily") {
        this.showDailySection = true;
        this.showWeeklySection = false;
        this.showMonthlySection = false;

        this.txtMonthlyDay = 0;
        this.selectedWeekdays = [];
      } else if (this.recurrencePatternRadioGroup == "Weekly") {
        this.showDailySection = false;
        this.showWeeklySection = true;
        this.showMonthlySection = false;

        this.txtMonthlyDay = 0;
        this.dailyOptionRadiogroup = "";
        this.txtMonthlyDay = "";
      } else {
        this.showDailySection = false;
        this.showWeeklySection = false;
        this.showMonthlySection = true;

        this.selectedWeekdays = [];
        this.dailyOptionRadiogroup = "";
        this.txtMonthlyDay = "";
      }
    },
    monthlyDayChange() {
      if (this.txtMonthlyDay > 31) {
        this.$toast.error("Days in a month can't be more that 31");
        this.isFormValid = false;
        this.txtMonthlyDay = 31;
      }
      if (this.txtMonthlyDay > 28 && this.txtMonthlyDay <= 31) {
        this.$toast.warning(
          "Some months have fewer than 29 days. For these months, the occurence will fall on last day of the month"
        );
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    deleteSlotItem(itemIndex) {
      this.timeslotsData.splice(itemIndex, 1);
    },
    addSlotItem() {
      this.resultArray = [];
      this.timeslotsData.push({
        startTime: "",
        endTime: "",
        organizers: []
      });
    },
    timeslotsDataChange(itemIndex, field, value) {
      if (field == "starttime") {
        this.timeslotsData[itemIndex]["startTime"] = value;
      } else if (field == "endtime") {
        this.timeslotsData[itemIndex]["endTime"] = value;
      } else if (field == "organizers") {
        this.resultArray = [];
        value.map(item => {
          let resultRow = {
            organizerEmail: "",
            organizerId: ""
          };
          this.organizersList.map(organizerItem => {
            if (item.email == organizerItem.email) {
              resultRow.organizerEmail = organizerItem.email;
              resultRow.organizerId = organizerItem.organizerId;
            }
          });

          this.resultArray.push(resultRow);
        });
        this.timeslotsData[itemIndex]["organizers"] = this.resultArray;
      }
    },
    addEventClick() {
      if (this.$refs.addEditEvent.validate()) {
        this.isaddingEvent = true;

        let eventFrequency;
        if (this.recurrencePatternRadioGroup == "Daily") {
          eventFrequency = this.dailyOptionRadiogroup;
        } else if (this.recurrencePatternRadioGroup == "Weekly") {
          eventFrequency = 3;
        } else {
          eventFrequency = 4;
        }

        this.addEventPayLoad = {
          eventType: this.selectedEventType,
          title: this.txtEventTitle,
          description: this.txtEventDescription,
          location: this.txtLocation,
          startDate: this.parseDate(this.startDateFormatted),
          endDate: this.parseDate(this.endDateFormatted),
          frequency: eventFrequency,
          days: this.selectedWeekdays.map(Number),
          dayOfMonth: Number(this.txtMonthlyDay),
          defaultTimeslots: this.timeslotsData,
          timezoneId: this.selectedTimeZone
        };
        eventsService.createEvent(
          this,
          data => {
            if (data.isSuccess) {
              this.$toast.success(data.systemMessage);
              this.$router.push("/events/all");
            } else {
              this.$toast.error(data.systemMessage);
            }
            this.isaddingEvent = false;
            //clear the form
            this.clearEventForm();
          },
          error => {
            console.log(error);
            this.isaddingEvent = false;
            this.$toast.error(
              "unable to add the event at this moment. Please try again later"
            );
          }
        );
      }
    },
    clearEventForm() {
      this.$refs.addEditEvent.reset();
      this.selectedWeekdays = [];
    },
    cancelEventForm() {
      this.$router.push("/events/all");
    },
    handleToggle() {
      if (this.isExpanded) {
        this.openedPanel = [0];
        this.showbanner = false;
      } else {
        this.openedPanel = [1];
        this.showbanner = true;
      }
    },
    toggleClick() {
      this.isExpanded = !this.isExpanded;
      this.handleToggle();
    },
    openModal() {
      this.$refs.modal.showModal();
    },
  }
};
